import { prepareRequest } from './request'
import SettingsManager from '../managers/settings'
import AccountManager from '../managers/account'

export const validateBets = (data) => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:validate',
    method: 'POST'
  })
  return request(data)
}

export const placeBets = data => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:place',
    method: 'POST'
  })
  return request(data)
}

export const getActiveRequests = () => {
  const request = prepareRequest({
    url: 'bettor/sport/bet/active/requests',
    method: 'GET'
  })
  return request()
}

export const asyncPlaceBets = data => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:placeAsync',
    method: 'POST'
  })
  return request(data)
}

export const calculateBetsLimits = data => {
  const request = prepareRequest({
    url: 'bettor/sport/bet/limits:calculate',
    method: 'POST'
  })
  return request(data)
}

export const searchBets = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:search',
    method: 'POST',
    query,
    signal
  })
  return request(body)
}

export const searchBetOrders = data => {
  const request = prepareRequest({
    url: 'ordering/bet:search',
    method: 'POST'
  })
  return request(data)
}

export const getBetsByStatuses = (betStatuses = [], options = {}, signal = null) => {
  const {
    itemsPerPage = 100,
    direction = 'DESC',
    fieldName = 'createTime',
    order = 0,
    view = 'BASIC'
  } = options

  return (
    searchBets({
      signal,
      body: {
        filter: {
          betStatuses
        },
        paging: {
          itemsPerPage
        },
        sorting: [
          { direction, fieldName, order }
        ]
      },
      query: {
        view
      }
    })
  )
}

export const getBetById = (betId) => {
  const request = prepareRequest({
    url: `bettor/sport/bet/${betId}`,
    method: 'GET'
  })
  return request()
}

export const submitBetCashout = data => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:cash-out',
    method: 'POST'
  })
  return request(data)
}

export const submitPartialBetCashout = data => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:partial-cash-out',
    method: 'POST'
  })
  return request(data)
}

export const estimateBetsCashout = bets => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:cash-out-estimate',
    method: 'POST'
  })
  return request({ bets })
}

export const estimatePartialBetsCashout = (bets) => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:cash-out-estimate',
    method: 'POST'
  })

  return request({
    bets,
    partialCashOut: true
  })
}

export const editBetRequest = data => {
  const request = prepareRequest({
    url: 'bettor/sport/bet:edit',
    method: 'POST'
  })

  return request(data)
}

export const getEditBetHistory = (betId) => {
  const request = prepareRequest({
    method: 'GET',
    url: `bettor/sport/bet/edit-history/${betId}`
  })

  return request()
}

export const getOutcomeLimits = ({ outcomeId, signal = null }) => {
  const request = prepareRequest({
    method: 'POST',
    url: '/bettor/sport/outcome:get-limits',
    signal
  })
  const { lang } = SettingsManager.settings
  const currency = AccountManager.getAccountCurrency() || 'AUD' // AUD for unlogged user

  return request({
    outcomeId,
    currency: currency,
    language: lang
  })
}
